import { format } from 'date-fns';

export const isValidDate = (value: unknown): value is Date => {
    return value instanceof Date && !Number.isNaN(value.getTime());
};

export const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString('en-GB');
};

export const formatPresentationDate = (date: string) => {
    return format(new Date(date), 'MMM d yyyy');
};

export const formatDateFromEpoch = (epoch: number | string) => {
    const date = new Date(Number(epoch));
    return date.toLocaleDateString('en-GB'); // 'en-GB' gives "DD/MM/YYYY" format
};

export const formatTime = (date: string) => {
    return new Date(date).toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
    });
};
